import { Component, Inject, OnInit } from "@angular/core";
import { SelectionModel } from "@angular/cdk/collections";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { nameBulkUpdateService } from "src/app/core/services/bulk-update-name.service";
import { CommonService } from "src/app/core/services/common.service";
import { areDistinct } from "../../utils/arrayUtils";
import { isEmpty } from "../../utils/commonUtils";

@Component({
  selector: "app-entity-dashboard-edit",
  templateUrl: "./entity-dashboard-edit.component.html",
  styleUrls: ["./entity-dashboard-edit.component.scss"],
})
export class EntityDashboardEditComponent implements OnInit {
  dataSource: MatTableDataSource<any>;
  columns: string[] = ["checkbox", "id", "name", "new_name"];
  pageLength: number;
  isValid: boolean = true;
  selection = new SelectionModel<any>(true, []);
  entityMapping = {
    insertion_order: "IO",
    line_item: "LI",
  };
  entityName: string;

  nameUpdateForm: Array<UntypedFormGroup> = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<EntityDashboardEditComponent>,
    private formBuilder: UntypedFormBuilder,
    private commonService: CommonService,
    private nameBulkUpdateService: nameBulkUpdateService
  ) {}

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.data.selectedItems);
    this.entityName = this.data.entityType.split("_").join(" ");
    this.pageLength = this.data.selectedItems.length;
    if (this.data.selectedItems && this.data.selectedItems.length) {
      for (let i = 0; i < this.data.selectedItems.length; i++) {
        this.nameUpdateForm.push(
          this.formBuilder.group({
            new_name: [
              {
                value: "",
                disabled:
                  this.data.entityType != "creative"
                    ? this.data.selectedItems[i].is_ended
                    : false,
              },
              [
                Validators.required,
                this.commonService.nameOverlap(
                  this.nameUpdateForm,
                  this.data.selectedItems,
                  "new_name"
                ),
              ],
            ],
          })
        );
      }
    }
    this.validate();
  }

  preparePayload(input) {
    const outputData = {};
    input.forEach((item) => {
      outputData[item.id.toString()] = item.new_name;
    });

    return {
      entity_type: this.data.entityType,
      data: outputData,
    };
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => this.selection.select(row));
  }

  isSomeSelected() {
    return this.selection.selected.length > 0;
  }

  update() {
    let payload = this.preparePayload(
      this.data.entityType == "creative"
        ? this.data.selectedItems
        : this.data.selectedItems.filter((item) => !item.is_ended)
    );

    this.nameBulkUpdateService
      .bulkUpdate(this.data.dsp, this.data.globalParams, payload)
      .subscribe(
        (res) => {},
        (err) => {},
        () => {
          this.closeModal(true);
        }
      );
  }

  closeModal(save: boolean = false) {
    this.dialogRef.close({
      save: save,
    });
  }

  deleteItems() {
    this.selection.selected.forEach((selected) => {
      let selected_index = this.data.selectedItems.indexOf(selected);
      this.nameUpdateForm.splice(selected_index, 1);
      this.data.selectedItems.splice(selected_index, 1);
    });
    this.selection.clear();
    this.data.selectedItems = JSON.parse(
      JSON.stringify(this.data.selectedItems)
    );
    this.dataSource = new MatTableDataSource(this.data.selectedItems);
    this.validate();
  }

  validate() {
    this.isValid = true;
    if (this.data.entity_type == "creative") {
      if (this.data.selectedItems.some((item) => isEmpty(item.new_name))) {
        this.isValid = false;
      }
    } else {
      if (
        this.data.selectedItems.some(
          (item) => isEmpty(item.new_name) && !item.is_ended
        )
      ) {
        this.isValid = false;
      }
    }

    if (!areDistinct(this.data.selectedItems.filter((item) => item.new_name), "new_name")) {
      this.isValid = false;
    }
  }

onNameChange(row) {
  row.new_name = row.new_name
    .replace(/\s+/g, ' ') // collapse multiple spaces
    .trim();              // remove leading/trailing spaces
}
}
